/**
 * Ticket Repository Hook
 *
 * Provides access to the ticket repository from the context.
 */

import { useRepositoryContext } from '../repositories';
import type { ITicketRepository } from '../repositories/interfaces/ITicketRepository';

/**
 * Hook to access the ticket repository
 * Must be used within a RepositoryProvider
 */
export function useTicketRepository(): ITicketRepository {
  const { tickets } = useRepositoryContext();
  return tickets;
}
